import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
// import { useMediaQuery } from 'react-responsive';

// import { useStoreState } from '../../common/storeContext'
import { GLOBAL_BUCKET, TENANT_NAME } from '../../common/constants'
import { useMiddletier } from "../../common/middletier";
import { SOCIAL_MEDIA_DATA } from '../../common/constants';
import "./template_01.css";

const Footer_01 = (props) => {
  // const appState = useStoreState()
  const [show, toggleShow] = React.useState(false);
  const { t, i18n } = useTranslation();
  const { queries } = useMiddletier();
  const [socialMedia, setSocialMedia] = useState([])
  const [paymentMethod, setPaymentMethod] = useState([])
  const [license, setLicense] = useState([])
  const [help, setHelp] = useState([])



  // const isDesktopOrLaptop = useMediaQuery({
  //   query: '(min-width: 992px)'
  // })
  const location = useLocation();

  const isProfilePage = location.pathname === '/my-profile';

  useEffect(() => {

    queries([{
      index: 'getSocialMedia',
      method: 'getSocialMedia',
      params: [],
      attributes: []
    },
    {
      index: 'getPaymentMethods',
      method: 'getPaymentMethods',
      params: [],
      attributes: []
    }, {
      index: 'getLicense',
      method: 'getLicense',
      params: [{ code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE' } } },],
      attributes: ['code']
    },
    {
      index: 'getFaq',
      method: 'getFaq',
      params: [{ code: 'language', graphqlType: 'String', required: true, value: i18n.resolvedLanguage },],
      attributes: []
    }
    ])
      .then(({ data }) => {

        const getSocialMediaData = data['getSocialMedia'].map((item) => {
          const _item = SOCIAL_MEDIA_DATA[item.code];
          return { ...item, value: JSON.parse(item.value), category: _item ? _item.category : null, icon: _item ? _item.icon : null };
        }).filter((item) => item.category === 'socialMedia' && item.value['url'] !== "");

        setSocialMedia(getSocialMediaData)
        setPaymentMethod(data['getPaymentMethods'])
        setLicense(data['getLicense'])
        setHelp(data['getFaq'])
        // console.log('hihi: ', getSocialMediaData)

      }).catch((error) => {
        console.log('error: ', error)
      })

  }, [queries, i18n.resolvedLanguage]);

  const { desktopToggle, mobileToggle, game_licenseToggle, certificationToggle, payment_methodToggle, suggested_browserToggle, follow_usToggle, responsible_gamingToggle, footer_titleToggle_desktop, footer_titleToggle_mobile, footer_infoToggle, position } = props;
  if (((desktopToggle || mobileToggle) === true) && !isProfilePage) {
    return (
      <footer className={`section ${desktopToggle ? "" : "d-lg-none"} ${mobileToggle ? "" : "d-none d-lg-block"}`} id="footer_01">
        <div className="footer font_h4 color_footer">
          <div className={`container-lg footer_container ${position === 'horizontal' ? 'footer_container_horizontal' : ''}`}>
            {/* <div className={`row footer_row 2 footer_menu_wrap ${footer_titleToggle_desktop ? "" : "d-lg-none"} ${footer_titleToggle_mobile ? "footer_title_m" : "d-none d-lg-block"}`}>
              <div className="font_h5 footer_help">
                <div><Link to="/contact-us" >{t('contact_us')}</Link>{position !== 'horizontal' && (<>︙</>)}</div>
              </div>
            </div> */}
            <div className="footer_info_container">
              {/* {footer_infoToggle && <div className="row footer_row 3 footer_seo_wrap">


                <div className="seo_footer_container">
                  {!show && <div className="text-uppercase m-0 seo_footer_title">{t('footer_title')}</div>}
                  <div className="font_h5 seo_footer_content">
                    {!show && t('footer_details')}
                    <span onClick={() => toggleShow(!show)}> {show ? t('hide_info') : t('read_more')}</span>
                    {show && (<div className="footer_seo_all">
                      <div className="footer_seo_all_col">
                        <div className="footer_seo__title">
                          {t('footer_details_title_01')}
                        </div>
                        <div className="footer_seo_details">
                          {t('footer_details_content_01')}
                        </div>
                        <div className="footer_seo__title">
                          {t('footer_details_title_02')}
                        </div>
                        <div className="footer_seo_details">
                          {t('footer_details_content_02')}
                        </div>
                      </div>
                      <div className="footer_seo_all_col">
                        <div className="footer_seo__title">
                          {t('footer_details_title_03')}
                        </div>
                        <div className="footer_seo_details">
                          {t('footer_details_content_03')}
                        </div>
                        <div className="footer_seo__title">
                          {t('footer_details_title_04')}
                        </div>
                        <div className="footer_seo_details">
                          {t('footer_details_content_04')}
                        </div>
                      </div>
                    </div>)
                    }
                  </div>
                </div>
                <div>


                </div>


              </div>}
              <div className="row footer_row footer_licenses_wrap">
                {game_licenseToggle &&
                  <div className="footer_info footer_gaming_license">
                    <div className="footer_title">{t('gaming_license')}</div>
                    <ul className="footer_info_img">
                      {license?.map(function (item, index) {
                        return (
                          <li key={item.code}>
                            <img src={`${GLOBAL_BUCKET}/gaming_license/${item.code}.png`} alt="footer license" />
                          </li>
                        )
                      })}
                    </ul>
                  </div>}

                {certificationToggle && <div className="footer_info">
                  <div className="footer_title">{t('certification')}</div>
                  <ul className="footer_info_img">
                    <li>
                      <img src={`${GLOBAL_BUCKET}/certifications/bmm.png`} alt="footer certification" />
                    </li>
                    <li>
                      <img src={`${GLOBAL_BUCKET}/certifications/itechlab.png`} alt="footer certification" />
                    </li>
                    <li>
                      <img src={`${GLOBAL_BUCKET}/certifications/secured.png`} alt="footer certification" />
                    </li>
                  </ul>
                </div>}



                {payment_methodToggle && <div className="footer_info footer_payment_method">
                  <div className="footer_title">{t('payment_methods')}</div>
                  <ul className="footer_info_img">
                    <li>
                      <img src={`${GLOBAL_BUCKET}/payment/BANKTRANSFER.png`} alt="footer payment method" />
                    </li>
                    {paymentMethod.map(function (item, index) {
                      return (
                        <li key={item.code}>
                          <img src={`${GLOBAL_BUCKET}/payment/${item.code}.png`} alt="" />
                        </li>
                      )
                    })}
             
                  </ul>
                </div>}

                {suggested_browserToggle && <div className="footer_info">
                  <div className="footer_title">{t('suggested_browser')}</div>
                  <ul className="footer_info_img">
                    <li>
                      <img src={`${GLOBAL_BUCKET}/browser/chrome.png`} alt="footer suggested browser" />
                    </li>
                    <li>
                      <img src={`${GLOBAL_BUCKET}/browser/firefox.png`} alt="footer suggested browser" />
                    </li>
                  </ul>
                </div>}



                {(follow_usToggle && socialMedia.length > 0) && <div className="footer_info footer_follow_us">
                  <div className="footer_title">{t('follow_us')}</div>
                  <ul className="footer_info_img">
                    {socialMedia.map(function (item, index) {
                      return (
                        <li key={item.code}>
                          <a href={item.value['url'] === "" ? "#" : item.value['url']} onClick={(e) => {
                            if (item.value['url'] === "") {
                              e.preventDefault();
                            }
                          }} target="_blank" rel="noopener noreferrer"> <img src={item.icon} alt={item.name} /></a>
                        </li>
                      )
                    })}
                   
                  </ul>
                </div>}

                {responsible_gamingToggle && <div className="footer_info">
                  <div className="footer_title">{t('responsible_gaming')}</div>
                  <ul className="footer_info_img">
                    <li>
                      <img src={`${GLOBAL_BUCKET}/responsible_gaming/18+.png`} alt="footer responsible gaming" />
                    </li>
                    <li>
                      <img src={`${GLOBAL_BUCKET}/responsible_gaming/begambleaware.png`} alt="footer responsible gaming" />
                    </li>
                    <li>
                      <img src={`${GLOBAL_BUCKET}/responsible_gaming/gamcare.png`} alt="footer responsible gaming" />
                    </li>
                  </ul>
                </div>
                }
              </div> */}

            </div>
            <div className="row footer_row">
              <div className="font_h5 footer_copyright_box">
                <div className="text-center footer_copyright">© 2025 Copyright: {TENANT_NAME.toUpperCase()}</div>
              </div>
              <div className="font_h5 footer_copyright_box footer_version_box">
                <div className="text-center footer_copyright">Version: {window.BUILD_VERSION}</div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  } else { }
};

export default Footer_01;
